import { render } from "./addModuleAgentRecharge.vue?vue&type=template&id=722453ed"
import script from "./addModuleAgentRecharge.vue?vue&type=script&lang=js"
export * from "./addModuleAgentRecharge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__